import React, { useEffect } from 'react';
import { useActiveListContext, useTaskContext } from '../../../context';
import { KEY_LISTS } from '../../../constants';
import { Desktop, Mobile } from '../../../media_queries';
import { KeyList } from './key-list';

export const KeyLists = ({setShowTasks = null}) => {
  const keyLists = KEY_LISTS;

  const { activeList, setActiveList } = useActiveListContext();
  const { filterTaskCounts } = useTaskContext();

  useEffect(() => {
    document.title = `${keyLists[0]} | Ame`;
  }, []);

  return (
    <>
      <Desktop>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {keyLists &&
            keyLists.map((keyList, index) => (
              <KeyList
                key={keyList}
                keyList={keyList}
                index={index}
                activeList={activeList}
                setActiveList={setActiveList}
                filterTaskCounts={filterTaskCounts}
              />
            ))}
        </div>
      </Desktop>
      <Mobile>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {keyLists &&
              keyLists.map(
                (keyList, index) =>
                  index < 2 && (
                    <KeyList
                      isMobile={true}
                      noMarginRight={index % 2 != 1 ? true : false}
                      key={keyList}
                      keyList={keyList}
                      index={index}
                      activeList={activeList}
                      setActiveList={setActiveList}
                      filterTaskCounts={filterTaskCounts}
                      setShowTasks={setShowTasks}
                    />
                  )
              )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {keyLists &&
              keyLists.map(
                (keyList, index) =>
                  index > 1 && (
                    <KeyList
                      isMobile={true}
                      noMarginRight={index % 2 != 1 ? true : false}
                      key={keyList}
                      keyList={keyList}
                      index={index}
                      activeList={activeList}
                      setActiveList={setActiveList}
                      filterTaskCounts={filterTaskCounts}
                      setShowTasks={setShowTasks}
                    />
                  )
              )}
          </div>
        </div>
      </Mobile>
    </>
  );
};
